@let hasServiceReadPermission =
  can(RoleAction.Read, RolePermissionSubject.Service);

@if (
  {
    activityVisibility: areActivitiesVisible$ | async,
  };
  as activityVisibilityData
) {
  <p class="mb-0">
    {{ 'general.activities' | translate }}
  </p>
  <nz-switch
    class="mb-2"
    [ngModel]="activityVisibilityData.activityVisibility"
    [nzDisabled]="
      !hasServiceReadPermission ||
      isCellView ||
      disabledActivityToggleOnLargerZoomLevel
    "
    nz-tooltip
    [nzTooltipTitle]="
      !hasServiceReadPermission ? ('general.forbidden_action' | translate) : ''
    "
    (ngModelChange)="
      toggleActivityVisibility(!!activityVisibilityData.activityVisibility)
    "
    data-test-id="wilson-timeline-render-activities-toggle"
  ></nz-switch>
}
